export { default } from './container';


// WEBPACK FOOTER //
// ./components/Agile/projectIssue/index.js